<template>
    <v-container fluid>
      <v-row>
        <v-col>
          <v-form ref="segment-update-form" @submit.prevent="updateSegment()">
            <v-text-field
              v-model="form.code"
              :rules="rules.required"
              label="Code"
              required
            ></v-text-field>
            <v-select
              v-model="form.color"
              :items="colors"
              :rules="rules.required"
              label="Couleur"
              required
            ></v-select>
            <v-text-field
              v-model="form.label"
              :rules="rules.required"
              label="Etiquette"
            ></v-text-field>
            <v-textarea
              v-model="form.description"
              label="Description"
            ></v-textarea>
            <v-btn type="submit" block class="mt-2">Enregistrer</v-btn>
          </v-form>
        </v-col>
      </v-row>
    </v-container>
  </template>
  
  <script>
  export default {
    data() {
      return {
        colors: [
          { value: "green", text: "Vert" },
          { value: "orange", text: "Orange" },
          { value: "purple", text: "Violet" },
          { value: "blue", text: "Bleu" },
          { value: "green-dark", text: "Vert sombre" },
          { value: "pink", text: "Rose" },
        ],
        form: {
          code: null,
          color: null,
          label: null,
          description: null,
          id: null,
        },
        rules: {
          required: [
            value => {
              if (value) return true
              return 'Vous devez saisir une valeur.'
            },
          ],
        }
      }
    },
    async created() {
        const segmentId = this.$route.params.segment
        await this.$store.dispatch('segments/getSegment', { segment_id: segmentId })
        const segment = this.$store.state.segments.selected
        this.form.id = segment.id
        this.form.description = segment.description
        this.form.label = segment.label
        this.form.color = segment.color
        this.form.code = segment.code
    },
    methods: {
      async updateSegment() {
        const formValidated = await this.$refs['segment-update-form'].validate()
        if (formValidated) {
          this.$store.dispatch("segments/updateSegment", this.form)
            .then(() => {
              this.$router.push({ name: "Segments" })
            })
        }
      }
    }
  }
  </script>